/** The label the agents table and the agent picker both show in their Type column. */
export const formatAgentType = (modelType: string): string => {
  switch (modelType) {
    case "MODEL_TYPE_CHAT":
      return "Chat"
    case "MODEL_TYPE_CHAT_A2A":
      return "A2A Chat"
    case "MODEL_TYPE_EMAIL":
      return "Email"
    case "MODEL_TYPE_VOICE":
      return "Voice"
    case "MODEL_TYPE_OUTBOUND_VOICE":
      return "Outbound Voice"
    case "MODEL_TYPE_SMS":
      return "SMS"
    case "MODEL_TYPE_WORKFLOW":
      return "Workflow"
    case "MODEL_TYPE_WEBSOCKET":
      return "WebSocket"
    case "MODEL_TYPE_SDK_WEBSOCKET":
      return "SDK WebSocket agent"
    case "MODEL_TYPE_CHAT_WEBSOCKET":
      return "Chat WebSocket"
    case "MODEL_TYPE_LIVEKIT":
      return "LiveKit"
    case "MODEL_TYPE_OPENAI_REALTIME":
      return "OpenAI Realtime"
    case "MODEL_TYPE_GEMINI_REALTIME":
      return "Gemini Live"
    case "MODEL_TYPE_GROK_REALTIME":
      return "Grok Realtime"
    case "MODEL_TYPE_DEEPGRAM_REALTIME":
      return "Deepgram Voice Agent"
    case "MODEL_TYPE_DAILY":
      return "Pipecat Cloud"
    default:
      return "Agent"
  }
}
